// Portal module gating helpers. Module ids equal frontend route ids, so the
// client's `portal_modules` array maps directly onto routes/nav. A null result
// means "legacy / not yet configured" → fall back to showing all portal modules.

export function enabledPortalRouteSet(client) {
    const mods = client?.portal_modules;
    if (!mods || mods.length === 0) return null; // legacy → all portal modules
    const set = new Set(mods);
    if (set.has("incidents")) set.add("safety-cross"); // safety-cross rides on incidents
    if (set.has("dashboard")) set.add("analytics"); // analytics rides on dashboard
    if (set.has("inductions")) set.add("onsite"); // "On Site" sign-in/out rides on the Inductions module
    set.add("learning"); // Help & Guides is universal — always available in the portal
    return set;
}
